<template>
  <div class="NotFound">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 style="text-align: center">
          <v-card height="400" color="transparent" flat>
            <div class="display-3 mt-5">{{ $t('Puslapis nerastas') }}</div>
            <div class="grey--text lighten-5 pt-2">
              {{
                $t(
                  'Atsiprašome, puslapis, kurį bandote atidaryti, neegzistuoja.'
                )
              }}
            </div>
            <div>
              <v-icon class="pt-4" size="10rem" color="#286c4536"
                >mdi-hand-back-left-outline</v-icon
              >
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.paragraph-text {
  font-size: 18px;
}
</style>
